import { Component, OnInit } from '@angular/core';
import {UserRoleCategoryModel} from '../../../shared/dto/user-role-category.model';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Status} from '../../../shared/enums/status.enum';
import {ActivatedRoute, Router} from '@angular/router';
import {UserroleCategoryService} from '../../../shared/service/userrole-category.service';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import swal from "sweetalert2";
import {UserRoleCategoryPopupComponent} from './user-role-category-popup/user-role-category-popup.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';

@Component({
  selector: 'app-user-roles-category',
  templateUrl: './user-roles-category.component.html',
  styleUrls: ['./user-roles-category.component.scss']
})
export class UserRolesCategoryComponent implements OnInit {
  status = Status;
  public form: FormGroup;
  userRoleCategories: UserRoleCategoryModel[] = [];
  public roleCategoryConfigItems: UserRoleCategoryModel[] = [];
  public href: string = "";

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userRoleCategoryService: UserroleCategoryService,
    private route: ActivatedRoute,
    public modalService: NgbModal,
    private spinnerService: NgxUiLoaderService,
    private tokenStorageService: TokenStorageService) {
  }

  ngOnInit() {
    this.form = new FormGroup({
      userRoleCategoryCode: new FormControl(null,Validators.required),
      status: new FormControl(null,Validators.required),
      description: new FormControl(null,Validators.required),
    });
    this.href = this.router.url;
    this.loadAllUserRoleCategory();
    this.onLoadGetData();
  }

  loadAllUserRoleCategory() {
    this.userRoleCategoryService.getAllUserRoleCategory().subscribe(
      (data: UserRoleCategoryModel[]) =>{
        this.userRoleCategories = data;
        this.roleCategoryConfigItems = data;
      }
    );
  }

  onLoadGetData(): void {
    const userRoleModel = new UserRoleCategoryModel(
      null,
      null,
      null,
      null,
      null,
      null);

    this.loadSearchResultList(userRoleModel);
  }

  loadSearchResultList(userRoleModel: UserRoleCategoryModel): void {
    this.spinnerService.start();
    this.userRoleCategoryService.getUserRoleCategoryDetails(userRoleModel).subscribe(
      (data: UserRoleCategoryModel[]) => {
        this.roleCategoryConfigItems = data;
      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();
        if (this.roleCategoryConfigItems == null || this.roleCategoryConfigItems.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadAllUserRoleCategory();
        } else {
          this.userRoleCategoryService.clearUserRoleSearchDetails();
          this.userRoleCategoryService.setUserRoleSearchDetails(
            this.roleCategoryConfigItems
          );
        }
      }
    );
  }

  onClickNew() {
    const modalRef = this.modalService.open(UserRoleCategoryPopupComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.name = 'Add New User Role Category';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
        this.loadAllUserRoleCategory();
      }
    }, () => {

    });
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onSubmitSearch(): void {
      const userRoleSearchDetails = new UserRoleCategoryModel(
        this.form.value.userRoleCategoryCode,
        this.form.value.description,
        this.form.value.status,
        this.tokenStorageService.getUserObjectToken().username,
        null,
        this.href
      );
      this.spinnerService.start();
      this.userRoleCategoryService.getUserRoleCategoryDetails(userRoleSearchDetails).subscribe(
        (data: UserRoleCategoryModel[]) => {
          this.roleCategoryConfigItems = data;
        },
        (error) => {
          this.spinnerService.stop();
          swal.fire('Sorry!', 'Something went wrong...!', 'error');
        },
        () => {
          this.spinnerService.stop();
          if (this.roleCategoryConfigItems == null || this.roleCategoryConfigItems.length === 0) {
            swal.fire('Sorry', 'No result found.', 'error');
            this.loadAllUserRoleCategory();
          } else {
            this.userRoleCategoryService.clearUserRoleSearchDetails();
            this.userRoleCategoryService.setUserRoleSearchDetails(
              this.roleCategoryConfigItems
            );
          }
        }
      );
  }

  onClickReset(): void {
    this.form.reset({
      userRoleCategoryCode: null,
      description: null,
      status: null,
    });
    this.onLoadGetData();
  }
}
